import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar'; 
import Footer from './Footer';

const AppLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <div className="mt-1">
          <Outlet />
        </div>
      </main>
      <Footer/>
    </div>
  );
};

export default AppLayout;